
export const isInfoNumber = (obj: unknown): obj is number => typeof obj === 'number' && !!Number(obj)

export enum CalculationTypes{
  FULL = 'full',
  PARTIAL = 'partial',
}

export enum ProgressionTypes {
  PROGRESSIVE = 'progressive',
  NORMAL = 'normal',
}
export interface InfoData {
  calculation?: CalculationTypes
  info: number | string
  progression?: ProgressionTypes
  title: string
}

export enum MarketingEvents {
  BLACK_WEEK = 'black-week',
  SINGLES_DAY = 'singles-day',
  FREE_SHIPPING = 'free-shipping',
}

const DATA = {
  [MarketingEvents.SINGLES_DAY]: {
    info: 11,
    title: 'common:SINGLES_DAY',
    calculation: CalculationTypes.PARTIAL,
    progression: ProgressionTypes.PROGRESSIVE,
  },
  [MarketingEvents.BLACK_WEEK]: {
    info: 20,
    title: 'common:BLACK_WEEK',
    calculation: CalculationTypes.PARTIAL,
    progression: ProgressionTypes.PROGRESSIVE,
  },
  [MarketingEvents.FREE_SHIPPING]: {
    info: 'shipping:FREE_SHIPPING_WEEKEND_INFO',
    title: 'shipping:FREE_SHIPPING_WEEKEND_TITLE',
    text: 'shipping:FREE_SHIPPING_WEEKEND_COUNTDOWN',
    textMobile: 'shipping:FREE_SHIPPING_WEEKEND_COUNTDOWN_MOBILE',
    calculation: CalculationTypes.FULL,
    progression: ProgressionTypes.PROGRESSIVE,
  },
}

export const getInfoData: Record<MarketingEvents, InfoData> = {
  ...DATA,
}

